import React from 'react';
import { Stack } from '@mui/material';
import Accept from './components/Accept';
import Edit from './components/Edit';
import Reject from './components/Reject';
import Chat from 'components/Chat';

const HandleWishlistButtons = ({ item, viewChat }) => {
	return (
		<Stack direction="row" justifyContent="space-between" alignItems="center" spacing={0} sx={{ width: '100%' }}>
			{item.responsible && (
				<Stack
					direction="row"
					justifyContent="flex-start"
					alignItems="flex-start"
					spacing={0.5}
					sx={{ width: { xs: '75%', md: '90%', sm: '85%' } }}
				>
					<Accept item={item} />
					<Edit item={item} />
					<Reject item={item} />
				</Stack>
			)}
			{item.special && viewChat && (
				<Stack
					direction="row"
					justifyContent="flex-end"
					alignItems="flex-start"
					spacing={0.5}
					sx={{
						width: {
							xs: item.responsible ? '25%' : '100%',
							md: item.responsible ? '10%' : '100%',
							sm: item.responsible ? '15%' : '100%'
						}
					}}
				>
					<Chat type="WISHLISTSPECIAL" id={item.wishlistId} titleChat={item.wishlistName} />
				</Stack>
			)}
		</Stack>
	);
};

export default HandleWishlistButtons;
